<div class="mb-3" [class.has-error]="showError" *ngIf="model.code">
  <a [href]="model.link" target="_blank">
    <img [src]="youtubeVideoService.getSrc(model)" alt="">
  </a>
</div>
